import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { FR } from '../lib/fr';
import { api } from '../lib/api';

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem('lang') || 'en');
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const setLang = (l) => { localStorage.setItem('lang', l); setLangState(l); if (localStorage.getItem('auth_token')) api.post('/me/preferences', { lang: l }).catch(() => {}); };
  const t = useCallback((s) => (lang === 'fr' ? (FR[s] || s) : s), [lang]);
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
